import { Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';

/**
 * Card do design system (vivest-card) com título e descrição opcionais.
 * O conteúdo do card é definido por quem usa o componente, via ng-content.
 * Um elemento com o atributo cardAcao é exibido à direita do título (ex.: um input ou radios).
 */
@Component({
  selector: 'app-card-conteudo',
  styleUrl: './card-conteudo.scss',
  templateUrl: './card-conteudo.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CardConteudo {
  readonly titulo = input<string>();
  readonly descricao = input<string>();
}
